// extracted by mini-css-extract-plugin
module.exports = {"polaroids":"polaroids-module--polaroids--1p3Cb","frame":"polaroids-module--frame--3DOKn"};